import { Divider, Stack } from '@mui/material'

import { SettingsCardBulkImport } from './SettingsCardBulkImport'
import { CopyAndPasteSectionBulkImport } from './CopyAndPasteSectionBulkImport'

export function SecondStepBulkImport() {
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        border: '1px solid #EAECF0',
        borderRadius: '16px',
        height: '100%',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <SettingsCardBulkImport />
      <Divider />
      <Stack
        sx={{
          borderLeft: '1px solid #D0D5DD',
          bgcolor: '#fff',
          paddingY: '20px',
          paddingX: '12px',
          flex: '1 0 0',
        }}
      >
        <CopyAndPasteSectionBulkImport />
      </Stack>
    </Stack>
  )
}
